export enum EventTrigger {
    Scheduled,
    Approval,
    Rejection,
    Manual
}
